module.exports = fox._r("images/empty-icon-comment.png", __webpack_public_path__ + "_/_/_/common/frame/images/empty-icon-comment.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/empty-icon-comment.png
// module id = 89
// module chunks = 2